export const puroStatisticsFrag = `
    date
    puroRef
    puroVyp    
    puroHo
    uhrHo
    uhrVyp
    uhrMnHo
    popHo
    popHoMn
    popHoReg
    popHoTotal
    popHoMnTotal
    popHoRegTotal
    points
    pointsMn
    pointsReg
    puroMaxVyp
    puroMax
    uhrMaxVyp
    uhrMax
`;

export const puroClientStatisticsFrag = `
    clients
    knAClients
    knBClients
    knCClients
    knABonified
    knBBonified
    knCBonified
    knAMax
    knBMax
    knCMax
    knMax
    pointPrice
    pointPriceVyp
`;

export const puroHighCostClientsFrag = `
    folderId
    folder {
       id
       personId
       person {
           id
           name
           surname
           titleBeforeName
           titleAfterName
           image
           sex
       }
    }
    percent
    cost
    remainingCost
`;

export const puroClientsFrag = `
    folderId
    folder {
        id
        personId
        person {
            id
            name
            surname
            titleBeforeName
            titleAfterName
            image
            sex
        }
    }
`;

export const puroUnlimitedPaymentsFrag = `
    hospiceClients
    hospiceCost
    foreignClients
    foreignCost
    childrenClients
    childrenCost
    travelCost
    totalClients
    totalCost
`;
